export const STARS_STR = "******";
